module.exports = {"id":"191488","name":"Lucas Orbán","rating":"74","photo":"./data/images/photos/0/191488.png","club":{"name":"Racing Club","logo":"./data/images/clubs/RacingClub.png"},"positions":["DC","DG"],"photoFolderIndex":0}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/LucasOrban0.json
// module id = 2579
// module chunks = 0